import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_CHAT } from './router';

menuRegistry.registerMenu([
    {
        parent: 'Multiplayer',
        key: 'Chat',
        name: 'Chat',
        icon: 'fas fa-comments'
    },
    {
        parent: 'Multiplayer.Chat',
        key: 'Sentence',
        name: 'Sentence',
        icon: 'fas fa-laugh',
        route: { name: ROUTE_NAME_CHAT.SENTENCE.INDEX }
    },
    {
        parent: 'Multiplayer.Chat',
        key: 'Setting',
        name: 'Setting',
        icon: 'fas fa-meh',
        route: { name: ROUTE_NAME_CHAT.SETTING }
    }
]);

export default registerRouteForModule(router);
